import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from '../context/TranslationContext';
import Logo from './Logo';

const COPY = {
  es: {
    links: [
      ['Qué hacemos', '/#que-hacemos'],
      ['Haz la cuenta', '/#cuenta'],
      ['Cómo trabajamos', '/#como-trabajamos'],
    ],
    cta: 'Pedir presupuesto',
    menu: 'Menú',
    close: 'Cerrar',
    skip: 'Saltar al contenido',
    lang: 'Idioma',
    home: 'Qyntix, inicio',
  },
  en: {
    links: [
      ['What we do', '/#que-hacemos'],
      ['Do the sum', '/#cuenta'],
      ['How we work', '/#como-trabajamos'],
    ],
    cta: 'Get a quote',
    menu: 'Menu',
    close: 'Close',
    skip: 'Skip to content',
    lang: 'Language',
    home: 'Qyntix, home',
  },
};

function NavLink({ label, href, className, onClick, current }) {
  if (href.startsWith('/#')) {
    return <a href={href} className={className} onClick={onClick}>{label}</a>;
  }
  return <Link to={href} className={className} aria-current={current ? 'page' : undefined}>{label}</Link>;
}

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const { lang, setLang } = useTranslation();
  const c = COPY[lang] || COPY.es;
  const onBlog = location.pathname.startsWith('/blog');

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location]);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === 'Escape' && setOpen(false);
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);

  return (
    <>
      <a className="skip-link" href="#main">{c.skip}</a>
      <header className={`site-header${scrolled || open ? ' is-scrolled' : ''}`}>
        <div className="wrap bar">
          <Logo label={c.home} />

          <nav className="nav" aria-label="Principal">
            {c.links.map(([label, href]) => (
              <NavLink key={href} label={label} href={href} current={href === '/blog' && onBlog} />
            ))}
          </nav>

          <div className="header-actions">
            <div className="lang" role="group" aria-label={c.lang}>
              <button type="button" lang="es" aria-pressed={lang === 'es'} onClick={() => setLang('es')}>ES</button>
              <span aria-hidden="true">/</span>
              <button type="button" lang="en" aria-pressed={lang === 'en'} onClick={() => setLang('en')}>EN</button>
            </div>
            <a href="/#contacto" className="btn btn-dark header-cta">{c.cta}</a>
            <button
              type="button"
              className="menu-toggle"
              aria-expanded={open}
              aria-controls="mobile-menu"
              onClick={() => setOpen((o) => !o)}
            >
              <span aria-hidden="true" />
              <span className="sr-only">{open ? c.close : c.menu}</span>
            </button>
          </div>
        </div>

        <div id="mobile-menu" className={`mobile-menu${open ? ' is-open' : ''}`}>
          <nav aria-label="Móvil">
            {c.links.map(([label, href]) => (
              <NavLink key={href} label={label} href={href} className="m-link" onClick={() => setOpen(false)} />
            ))}
          </nav>
          <a href="/#contacto" className="m-link btn" onClick={() => setOpen(false)}>{c.cta}</a>
        </div>
      </header>
    </>
  );
}
